<template>
    <Sidebar>
        <template #header>
            <div class="sidebar-header-content">
                <p class="bold-heading">Item Details</p>
                <p><i @click="$emit('close')" class="pi pi-times pt-3" style="font-size: 1.5rem; color: #000000;"></i>
                </p>
            </div>
        </template>
        <div class="Details-container">
            <b-row>
                <b-col>
                    <div class="d-flex">
                        <img src="../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                        <h6 class="bold-heading mt6 ms-1">Quotes Details</h6>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <ItemDetails />
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                </b-col>
            </b-row>
            <b-row class="my-3">
                <b-col>
                    <div class="d-flex mt-3">
                        <img src="../../../../../assets/Img/icons/downsymbol.svg" alt="" class="down-symbol">
                        <h6 class="bold-heading mt6 ms-1">Rack-Box Mapping</h6>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <RackBoxMapping />
                </b-col>
            </b-row>
        </div>
    </Sidebar>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'


import { GChart } from "vue-google-charts";

//TableComponent


//Component
import RackBoxMapping from '../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/RackBoxMapping.vue';
import Pricing from '../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/Pricing.vue';
import ItemDetails from '../../../../../modules/Inventory/components/Sidebar/RightSidebar/component/ItemDetails.vue';


export default defineComponent({
    components: {

        GChart,
        //Table Component
        //component
        RackBoxMapping,
        Pricing,
        ItemDetails,
    },
    props: {
        trigger: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        const active = ref(true)
        const placement = ref('right')
        const data = [
            ['Element', 'Density', { role: 'style' }],
            ['Print Media', 9.95, '#dab8a7'],
            ['Social Media', 55.55, '#dab8a7'],
            ['Brodcast Media', 52.99, '#dab8a7'],
            ['Outdoor', 30.55, 'color: #dab8a7'],
            ['Internet', 45.21, 'color: #dab8a7']
        ]
        const options = {
            width: 285,
            height: 200
        }

        return {

            data,
            options,
            active,
            placement
        }
    }

})
</script>

<style lang="scss">
.line {
    width: 100%;
    height: 4px;
    background-color: #0148E2;
}

.Details-container {
    padding: 7px;

    .high-val {
        font-size: 14px;
        color: blue;

    }

    .sidbar-label {
        font-size: 13px;
        color: #999999;
    }

    .sidbar-val {
        font-size: 13px;
        color: #444444;
    }

    .closed {

        text-align: end;
    }

    .sub-heading {
        text-align: left;
        padding: 15px 0px;
        font-weight: 500;
        font-size: 13px;
        color: #000000;


    }

    .chartbar {
        background-color: rgb(255, 255, 255);
    }

    .Avail-box:hover {

        background-color: #28C840;

        .Avail-select,
        .Avail-select1 {
            background-color: #1C47D9;
        }

        .Avail-count {
            color: #FFFFFF;
        }

        .Avail-content {
            color: #FFFFFF;
        }
    }


    .Avail-box {
        cursor: pointer;
        padding: 10px 5px;
        border-radius: 10px;

        .Avail-select {
            border-radius: 50%;
            margin: 5px;
            margin-left: 0px;
            width: 9px;
            height: 8px;
            background-color: #ADAADB;
        }

        .Avail-select1 {
            border-radius: 50%;
            margin: 5px;
            margin-left: 0px;
            width: 17px;
            height: 8px;
            background-color: #ADAADB;
        }

        .Avail-count {
            font-size: 15px;
            color: #000000;
            text-align: center;
        }

        .Avail-content {
            font-size: 9px;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }


    .i-count {
        background-color: #28C840;
        border-radius: 6px;
    }

    .I-heading {
        font-size: 15px;
        text-align: left;
        padding: 10px;
        font-weight: 600;
        color: #FFFFFF;
    }

    .close {
        text-align: end;
    }

    .tablet-id {
        font-weight: 200;
        font-size: 12px;
        color: #999999;
    }

    .tablet-name {
        font-weight: 300;
        font-size: 15px;
        color: #000000;
        font-weight: 500;
        letter-spacing: 1px;
    }

    .I-img {
        margin: 10px;
        width: 30px;
    }

    .d-heading {
        text-align: left;
        font-size: 13px;
        font-weight: 600;
        color: #000000;
    }

    .v-details {
        text-align: right;
        font-size: 13px;
        font-weight: 400;
        color: #3096FF;
    }
}

.txt-blue-sm {
    font-size: 12px;
    color: #3096FF;
}

.p-sidebar-header-content {
    width: 100%;
}

.sidebar-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>